import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=f33e02c6&"
import script from "./Complaint.vue?vue&type=script&lang=js&"
export * from "./Complaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f33e02c6')) {
      api.createRecord('f33e02c6', component.options)
    } else {
      api.reload('f33e02c6', component.options)
    }
    module.hot.accept("./Complaint.vue?vue&type=template&id=f33e02c6&", function () {
      api.rerender('f33e02c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/Edit/Complaint.vue"
export default component.exports